import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "text-center lead",
  style: {"font-size":"1.5rem"}
}
const _hoisted_2 = {
  key: 0,
  class: "card card-collapsable mt-1"
}
const _hoisted_3 = {
  id: "cardQuestion",
  class: "card-body collapse show pt-4"
}
const _hoisted_4 = { style: {"min-height":"450px"} }
const _hoisted_5 = { class: "list-group" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { style: {"margin-top":"15px"} }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 1,
  style: {"min-height":"450px"}
}
const _hoisted_12 = { class: "list-group" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_15 = {
  key: 0,
  class: "text-center"
}
const _hoisted_16 = { style: {"margin-top":"15px"} }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 2,
  class: "mt-4 DirectRateVotesBrowserView",
  style: {"min-height":"500px"}
}
const _hoisted_19 = { class: "nav nav-tabs" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = { class: "tab-content" }
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = { class: "table table-striped" }
const _hoisted_26 = { style: {"text-align":"center"} }
const _hoisted_27 = { style: {"text-align":"left"} }
const _hoisted_28 = ["colspan"]
const _hoisted_29 = { style: {"text-align":"left"} }
const _hoisted_30 = ["colspan"]
const _hoisted_31 = { class: "table-responsive" }
const _hoisted_32 = { class: "table" }
const _hoisted_33 = {
  style: {"text-align":"center"},
  class: "bottom noborder"
}
const _hoisted_34 = { style: {"height":"400px","border":"none","padding-top":"20px"} }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { style: {"text-align":"center"} }
const _hoisted_37 = { style: {"width":"5%"} }
const _hoisted_38 = { class: "blockquote" }
const _hoisted_39 = { class: "mb-0" }
const _hoisted_40 = { class: "blockquote-footer" }

import { ref, computed } from 'vue'
    import { boolCompare, isNullOrWhitespace, numCompare } from '@common/Common'

    import type { ScoringVoteEntry } from '@Evaluation/AlternativesSurveys/Domain/readmodels'
    import type { DiscreteScaleLevelReadModel } from '@Scales/readmodels'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingQuestionReviewDr',
  props: {
    propIsMeetingManager: { type: Boolean },
    propContextName: {},
    propAlternativeName: {},
    propVotesEntries: {},
    propScaleLevels: {},
    propValue: {},
    propComment: {}
  },
  emits: ["update-vote-value", "update-vote-comment", "show-alternative-details", "show-criterion-details"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- local state ---------------- */

    const ActiveTab = ref<'votes' | 'summary' | 'notes'>('votes')

    /* ---------------- derived ---------------- */

    const isMeetingManager = computed(() => props.propIsMeetingManager)
    const contextName = computed(() => props.propContextName)
    const alternativeName = computed(() => props.propAlternativeName)

    const votesEntries = computed(() => props.propVotesEntries)
    const scaleLevels = computed(() => props.propScaleLevels)

    const value = computed<number | null>(() => props.propValue ?? null)
    const comment = computed<string | null>(() => props.propComment ?? null)

    /* ---------------- scale helpers ---------------- */

    const QuestionScale = computed<number[]>(() =>
        scaleLevels.value
            .map(l => l.Value)
            .sort((a, b) => numCompare(a, b))
    )

    /* ---------------- table helpers ---------------- */

    function getDrTableCells(val: number | null): TdViewModel[]
    {
        const cells = QuestionScale.value.map(v => new TdViewModel(v, false, false))
        if (val == null) return cells

        const exact = cells.find(c => Math.round(c.Value * 100) === Math.round(val * 100))
        if (exact)
        {
            exact.Highlighted = true
            return cells
        }

        const prevCount = QuestionScale.value.filter(v => v < val).length
        const prev = cells[prevCount - 1]

        prev.Highlighted = true
        prev.Value = val
        prev.Colspan = 2

        cells.splice(prevCount, 1)
        return cells
    }

    /* ---------------- votes view ---------------- */

    const VotesEntriesView = computed(() =>
        votesEntries.value
            .map(e => new VoteEntryViewModel(getDrTableCells, e))
            .sort((a, b) => boolCompare(a.SurveyId != null, b.SurveyId != null))
    )

    const Comments = computed(() =>
        votesEntries.value.filter(e => !isNullOrWhitespace(e.Comment))
    )

    /* ---------------- averages & histogram ---------------- */

    const Average = computed<number | null>(() =>
    {
        const valid = votesEntries.value.filter(e => e.Value != null && e.VoteStrength > 0)
        if (!valid.length) return null

        const weightedSum = valid.reduce(
            (sum, e) => sum + e.VoteStrength * e.Value,
            0
        )
        const weights = valid.reduce((sum, e) => sum + e.VoteStrength, 0)

        return weightedSum / weights
    })

    const AverageCells = computed(() => getDrTableCells(Average.value))

    const HistogramValues = computed(() =>
    {
        const voteValues = votesEntries.value.filter(e => e.Value != null).map(e => e.Value)
        const uniqueValues = new Set([...QuestionScale.value, ...voteValues])
        const orderedValues = [...uniqueValues].sort((a, b) => b - a)

        let maxCount = 0
        for (const v of orderedValues)
        {
            maxCount = Math.max(maxCount, voteValues.filter(x => x === v).length)
        }

        return orderedValues.map(v =>
        {
            const count = voteValues.filter(x => x === v).length
            return {
                Value: v,
                Count: count,
                PercentOfMax: maxCount ? Math.round((count / maxCount) * 100) : 0
            }
        })
    })

    /* ---------------- tab helpers ---------------- */

    const VotesTabActive = computed(() => ActiveTab.value === 'votes')
    const SummaryTabActive = computed(() => ActiveTab.value === 'summary')
    const CommentsTabActive = computed(() => ActiveTab.value === 'notes')

    /* ---------------- actions ---------------- */

    function updateValue(v: number | null)
    {
        emit('update-vote-value', v)
    }

    function updateComment(c: string)
    {
        emit('update-vote-comment', c)
    }

    function showAlternativeDetails()
    {
        emit('show-alternative-details')
    }

    function showCriterionDetails()
    {
        emit('show-criterion-details')
    }

    /* ---------------- local view models ---------------- */

    class VoteEntryViewModel
    {
        Id: string
        VotesSourceName: string
        VoteStrength: number
        Value: number
        Comment: string
        SurveyId?: number
        ProjectUserId?: number

        constructor(
            private readonly getCells: (v: number | null) => TdViewModel[],
            voteEntry: ScoringVoteEntry
        )
        {
            this.Id = `${voteEntry.SurveyId}.${voteEntry.ProjectUserId}`
            this.VotesSourceName = voteEntry.VotesSourceName
            this.VoteStrength = voteEntry.VoteStrength
            this.Value = voteEntry.Value
            this.Comment = voteEntry.Comment
            this.SurveyId = voteEntry.SurveyId
            this.ProjectUserId = voteEntry.ProjectUserId
        }

        get cells(): TdViewModel[]
        {
            return this.getCells(this.Value)
        }
    }

    class TdViewModel
    {
        Colspan: number
        Highlighted: boolean
        Value: number

        constructor(value: number, highlighted: boolean, colspan: boolean)
        {
            this.Value = value
            this.Highlighted = highlighted
            this.Colspan = colspan ? 2 : 1
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, [
      _cache[7] || (_cache[7] = _createTextVNode(" How would you rate: ", -1 /* CACHED */)),
      _createElementVNode("a", {
        class: "text-primary",
        title: "Show description",
        onClick: showAlternativeDetails
      }, _toDisplayString(alternativeName.value), 1 /* TEXT */),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _cache[9] || (_cache[9] = _createTextVNode(" in the context of: ", -1 /* CACHED */)),
      _createElementVNode("a", {
        class: "text-primary",
        title: "Show description",
        onClick: showCriterionDetails
      }, _toDisplayString(contextName.value), 1 /* TEXT */),
      _cache[10] || (_cache[10] = _createTextVNode("? ", -1 /* CACHED */))
    ]),
    (isMeetingManager.value === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[13] || (_cache[13] = _createElementVNode("div", {
            class: "card-header pointer",
            "data-toggle": "collapse",
            href: "#cardQuestion"
          }, " Group vote ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scaleLevels.value, (l) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: l.Value,
                    class: _normalizeClass(["list-group-item list-group-item-action text-center", { 'bg-success': value.value === l.Value, 'bg-white': value.value !== l.Value }]),
                    onClick: ($event: any) => (updateValue(l.Value))
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(l.Value) + " - " + _toDisplayString(l.Name), 1 /* TEXT */),
                    (l.Definition)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(l.Definition), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 10 /* CLASS, PROPS */, _hoisted_6))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn mt-3", value.value == null ? 'btn-success' : 'btn-outline-secondary']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (updateValue(null)))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fa-regular", value.value == null ? 'fa-square-check' : 'fa-square']),
                    "aria-hidden": "true"
                  }, null, 2 /* CLASS */),
                  _cache[11] || (_cache[11] = _createTextVNode(" Follow the average (default) ", -1 /* CACHED */))
                ], 2 /* CLASS */)
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("textarea", {
                  rows: "5",
                  value: comment.value,
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (updateComment($event.target.value))),
                  class: "form-control",
                  placeholder: "Comment..."
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_10)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (isMeetingManager.value === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scaleLevels.value, (l) => {
              return (_openBlock(), _createElementBlock("a", {
                key: l.Value,
                class: _normalizeClass(["list-group-item list-group-item-action text-center", { 'bg-success': value.value === l.Value, 'bg-white': value.value !== l.Value }]),
                onClick: ($event: any) => (updateValue(l.Value))
              }, [
                _createElementVNode("strong", null, _toDisplayString(l.Value) + " - " + _toDisplayString(l.Name), 1 /* TEXT */),
                (l.Definition)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(l.Definition), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 10 /* CLASS, PROPS */, _hoisted_13))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          (value.value != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link mt1",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (updateValue(null)))
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("i", {
                    class: "fa fa-times",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Clear answer ", -1 /* CACHED */)
                ]))])
              ]))
            : _createCommentVNode("v-if", true),
          _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("textarea", {
              rows: "5",
              value: comment.value,
              onInput: _cache[3] || (_cache[3] = ($event: any) => (updateComment($event.target.value))),
              class: "form-control",
              placeholder: "Comment..."
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_17)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (isMeetingManager.value === true || votesEntries.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("ul", _hoisted_19, [
            _createElementVNode("li", _hoisted_20, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {'active': VotesTabActive.value}]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (ActiveTab.value = 'votes'))
              }, "Votes", 2 /* CLASS */)
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {'active': SummaryTabActive.value}]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (ActiveTab.value = 'summary'))
              }, "Chart", 2 /* CLASS */)
            ]),
            _createElementVNode("li", _hoisted_22, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", {'active': CommentsTabActive.value}]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (ActiveTab.value = 'notes'))
              }, "Comments", 2 /* CLASS */)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (VotesTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([{'active': VotesTabActive.value}, "tab-pane pt-2"])
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("table", _hoisted_25, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_26, [
                          _createElementVNode("td", _hoisted_27, [
                            _createElementVNode("strong", null, "Average (" + _toDisplayString(Average.value != null ? Average.value.toFixedIfNeeded(2) : 'N/A') + ")", 1 /* TEXT */)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(AverageCells.value, (cell) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: _normalizeClass({ 'bg-color-gray': cell.Highlighted }),
                              colspan: cell.Colspan,
                              style: _normalizeStyle({'width': cell.Colspan === 1 ? '5%' : '10%'})
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass({ 'fg-color-white': cell.Highlighted })
                              }, _toDisplayString(cell.Value.toFixedIfNeeded(2)), 3 /* TEXT, CLASS */)
                            ], 14 /* CLASS, STYLE, PROPS */, _hoisted_28))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(VotesEntriesView.value, (e) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            style: {"text-align":"center"},
                            key: e.Id
                          }, [
                            _createElementVNode("td", _hoisted_29, _toDisplayString(e.VotesSourceName ?? '???'), 1 /* TEXT */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(e.cells, (cell) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: cell.Value,
                                colspan: cell.Colspan,
                                class: _normalizeClass({ 'bg-color-green': cell.Highlighted })
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'fg-color-white': cell.Highlighted })
                                }, _toDisplayString(cell.Value.toFixedIfNeeded(2)), 3 /* TEXT, CLASS */)
                              ], 10 /* CLASS, PROPS */, _hoisted_30))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            (SummaryTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([{'active': SummaryTabActive.value} , "tab-pane pt-2"])
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("table", _hoisted_32, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_33, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(HistogramValues.value, (v) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_34, [
                              (v.Count)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(v.Count), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", {
                                class: "bg-color-green2",
                                style: _normalizeStyle({'height': v.PercentOfMax + '%'})
                              }, null, 4 /* STYLE */)
                            ]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _createElementVNode("tr", _hoisted_36, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(HistogramValues.value, (v) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(v.Value.toFixedIfNeeded(2)), 1 /* TEXT */))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ])
                    ])
                  ])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            (CommentsTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass([{ 'active': CommentsTabActive.value }, "tab-pane pt-2"])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Comments.value, (c) => {
                    return (_openBlock(), _createElementBlock("blockquote", _hoisted_38, [
                      _createElementVNode("p", _hoisted_39, _toDisplayString(c.Comment), 1 /* TEXT */),
                      _createElementVNode("footer", _hoisted_40, _toDisplayString(c.VotesSourceName ?? '???'), 1 /* TEXT */)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})